export default __webpack_public_path__ + "static/avatar-kayi-common-3-104d0c48535268960753aed59ec7a262.png";